// VoK MUI base styles
import colors from "app/assets/theme-dark/base/colors";

const {dark} = colors;

const formLabel = {
    styleOverrides: {
        root: {
            color: dark.main,
        },
    },
};

export default formLabel;
